import _ from "underscore";
import UserNodeRenderer from "./UserNodeRenderer";

export default function EmailCheckUserNodeRenderer( tree, selectorFilter, selectionHelper, checkEmail, messageParams)
{
    UserNodeRenderer.call(this, tree, selectorFilter, selectionHelper);
    this.checkEmail = checkEmail;
    this.messageParams = messageParams;
    this.invalidClassName = "invalidNode";
}

EmailCheckUserNodeRenderer.prototype = _.create(UserNodeRenderer.prototype);

EmailCheckUserNodeRenderer.prototype.isBadEmail = function(user)
{
    return this.checkEmail && !user.hasEmail();
};

EmailCheckUserNodeRenderer.prototype.getNodeClasses = function ( treeNode )
{
    var classes = UserNodeRenderer.prototype.getNodeClasses.call(this, treeNode);
    if (this.isInvalidUser(treeNode.getValue()))
    {
        classes.push(this.getInvalidClassName());
    }
    return classes;
};

EmailCheckUserNodeRenderer.prototype.isInvalidUser = function(user)
{
    return this.isBadEmail(user);
};

EmailCheckUserNodeRenderer.prototype.getDisabledClassName = function()
{
    return this.getInvalidClassName();
};

EmailCheckUserNodeRenderer.prototype.getInvalidClassName = function()
{
    return this.checkEmail ? this.invalidClassName : this.disabledClassName;
};

EmailCheckUserNodeRenderer.prototype.getTitle = function(user) {
    if (this.checkEmail)
    {
        if (!user.isActive())
        {
            return this.messageParams.getDisabledMessage(user);
        }
        var additionalTitle = this.getAdditionalTitle( user );
        if (additionalTitle)
        {
            return additionalTitle;
        }
        if (this.isBadEmail(user))
        {
            return this.messageParams.getNoEmailMessage(user);
        }
    }
    return UserNodeRenderer.prototype.getTitle.call(this, user);
};

EmailCheckUserNodeRenderer.prototype.getAdditionalTitle = function(user)
{
    return null;
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/EmailCheckUserNodeRenderer.js